module.exports = __webpack_public_path__ + "static/media/18_r_lenti_80.16_0.06e916b9.png";